import Bold from 'src/assets/icons/rich-text-editor/Bold';
import Italic from 'src/assets/icons/rich-text-editor/Italic';
import Underline from 'src/assets/icons/rich-text-editor/Underline';
import Strikethrough from 'src/assets/icons/rich-text-editor/Strikethrough';
import HeadingOne from 'src/assets/icons/rich-text-editor/HeadingOne';
import HeadingTwo from 'src/assets/icons/rich-text-editor/HeadingTwo';
import HeadingThree from 'src/assets/icons/rich-text-editor/HeadingThree';
import BulletedList from 'src/assets/icons/rich-text-editor/BulletedList';
import NumberedList from 'src/assets/icons/rich-text-editor/NumberedList';
import Link from 'src/assets/icons/rich-text-editor/Link';
import BlockQuote from 'src/assets/icons/rich-text-editor/BlockQuote';
import AlignLeft from 'src/assets/icons/rich-text-editor/AlignLeft';
import AlignRight from 'src/assets/icons/rich-text-editor/AlignRight';
import AlignCenter from 'src/assets/icons/rich-text-editor/AlignCenter';

export const SLATE_NODE_TYPES = {
  BLOCK: 'block',
  INLINE: 'inline',
  MARK: 'mark',
};
export const SLATE_TEXT_FORMATS = {
  PARAGRAPH: 'paragraph',
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough',
  ALIGN_LEFT: 'left',
  ALIGN_CENTER: 'center',
  ALIGN_RIGHT: 'right',
  HEADING_ONE: 'heading-one',
  HEADING_TWO: 'heading-two',
  HEADING_THREE: 'heading-three',
  HEADING_FOUR: 'heading-four',
  HEADING_FIVE: 'heading-five',
  HEADING_SIX: 'heading-six',
  BLOCK_QUOTE: 'block-quote',
  BULLETED_LIST: 'bulleted-list',
  NUMBERED_LIST: 'numbered-list',
  LIST_ITEM: 'list-item',
  LINK: 'link',
  IMG: 'image',
  DD_VARIATION: 'dd-variation',
};

export const VOID_ELEMENTS = {
  DIVIDER: 'divider',
};

export const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify'];

export const LIST_TYPES = [
  SLATE_TEXT_FORMATS.NUMBERED_LIST,
  SLATE_TEXT_FORMATS.BULLETED_LIST,
];

export const HEADING_TYPES = [
  SLATE_TEXT_FORMATS.HEADING_ONE,
  SLATE_TEXT_FORMATS.HEADING_TWO,
  SLATE_TEXT_FORMATS.HEADING_THREE,
  SLATE_TEXT_FORMATS.HEADING_FOUR,
  SLATE_TEXT_FORMATS.HEADING_FIVE,
  SLATE_TEXT_FORMATS.HEADING_SIX,
];
export const SLATE_ACTIONS = {
  UNDO: 'undo',
  REDO: 'redo',
  CLEAR_FORMAT: 'clear-format',
};

export const SLATE_FORMAT_ACTIONS = {
  [SLATE_TEXT_FORMATS.BOLD]: {
    icon: Bold,
    label: 'Bold',
  },
  [SLATE_TEXT_FORMATS.ITALIC]: {
    icon: Italic,
    label: 'Italic',
  },
  [SLATE_TEXT_FORMATS.UNDERLINE]: {
    icon: Underline,
    label: 'Underline',
  },
  [SLATE_TEXT_FORMATS.STRIKETHROUGH]: {
    icon: Strikethrough,
    label: 'Strikethrough',
  },
  [SLATE_TEXT_FORMATS.LINK]: {
    icon: Link,
    label: 'Link',
  },
  [SLATE_TEXT_FORMATS.HEADING_ONE]: {
    icon: HeadingOne,
    label: 'Heading 1',
  },
  [SLATE_TEXT_FORMATS.HEADING_TWO]: {
    icon: HeadingTwo,
    label: 'Heading 2',
  },
  [SLATE_TEXT_FORMATS.HEADING_THREE]: {
    icon: HeadingThree,
    label: 'Heading 3',
  },
  [SLATE_TEXT_FORMATS.BULLETED_LIST]: {
    icon: BulletedList,
    label: 'Bullet list',
  },
  [SLATE_TEXT_FORMATS.NUMBERED_LIST]: {
    icon: NumberedList,
    label: 'Numbered list',
  },
  [SLATE_TEXT_FORMATS.BLOCK_QUOTE]: {
    icon: BlockQuote,
    label: 'Blockquote',
  },
  [SLATE_TEXT_FORMATS.ALIGN_RIGHT]: {
    icon: AlignRight,
    label: 'Right align',
  },
  [SLATE_TEXT_FORMATS.ALIGN_LEFT]: {
    icon: AlignLeft,
    label: 'Left align',
  },
  [SLATE_TEXT_FORMATS.ALIGN_CENTER]: {
    icon: AlignCenter,
    label: 'Center align',
  },
};

export const DEFAULT_SLATE_VALUE = [
  {
    type: SLATE_TEXT_FORMATS.PARAGRAPH,
    children: [{ text: '' }],
  },
];
